import React, { useState, useRef } from "react";
import { Typography } from "@mui/material";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import swal from "sweetalert";
import * as api from "../../../actions/api";
import DispenserFormData from "./DispenseItems.js";
// import history from './../../../history';
import { useTranslation } from "react-i18next";

import { format } from 'date-fns';
import encryptionService from "../../../services/encryptionService";
//let mApiUrl = api.updateDispenseInv;

const EditDispenser = (props) => {
  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "dispense";
  const FacilityId = localStorage.getItem("FacilityId");

  const { t, i18n } = useTranslation();

  const [formData, setFormData] = useState({
    TransactionDate: "",
    //SupplierInvDate: "",
    // SupplierInvNo: "",
    TransactionNo: "",
    FacilityId: FacilityId,
    TransactionTypeId: 4,
    // OrderNo:"",
    //ReceiveFrom:"",
    PreparedBy: "",
    ApprovedBy: "",
    ItemGroupId: "",
  });
  const [selectedDate, setSelectedDate] = useState(
    //new Date()
    format(new Date(), 'yyyy-MM-dd')
  );
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const [ManyTableData, setManyTableData] = useState([]);
  const [bStockUpdate, setbStockUpdate] = useState("0");
  const [updatedDetailGridData, setUpdatedDetailGridData] = useState([]);
  const [TransactionId, setTransactionId] = useState("0");
  const [deletedDataSet, setDeletedDataSet] = useState([]);

  const [StockPost, setStockPost] = useState(false);

  const [generatedInvoiceNo, setGeneratedInvoiceNo] = useState("");

  const [bFirst, setBFirst] = useState(true);

  const saveInFlightRef = useRef(false);

  const handleRDateChange = (date, field) => {
    let newDate;
    if (date == null) {
      newDate = date;
    } else {
      newDate = format(new Date(date), 'yyyy-MM-dd');
    }
    setFormData({ ...formData, [field]: newDate });
    setErrorObject({ ...errorObject, [field]: null });
  };

  const [errorObject, setErrorObject] = useState({});
  const { id } = useParams();
  const queryClient = useQueryClient();

  const { data, refetch } = useQuery(
    ["dispense", id],
    () =>
      api.getDispenseInv(id).then((res) => {
        //This is for user has VIEW/EDIT permission in this page start
        if (props.permissionType === 1) {
          //when permissionType then it is only VIEW permission otherwise normal permission
          res.data.bStockUpdated = 1;
        }
        //This is for user has VIEW/EDIT permission in this page end

        setTransactionId(id);
        setFormData(res.data);
        setbStockUpdate(res.data.bStockUpdated);
        setManyTableData(res.data.ManyJsonSave); //res.data.ManyJsonSave
        setUpdatedDetailGridData(res.data.ManyJsonSave);
        setGeneratedInvoiceNo(res.data.TransactionNo);
        setDeletedDataSet([]);
        setBFirst(true);

        return res.data;
      }),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(id),
    }
  );

  const { isLoading: isUpdateMutating, mutate: mutateUpdate } = useMutation(
    api.updateDispenseInv,
    {
      onSuccess: (data) => {
        if (data.status == 200) {
          setbStockUpdate(data.bStockUpdated);
          if (data.bStockUpdated == 1) {
            mutatePost(TransactionId);
          } else {
            refetch();

            props.openNoticeModal({
              isOpen: true,
              msg: data.message,
              msgtype: data.success,
            });

            //swal("Success!", "", "success");
          }
        } else {
          props.openNoticeModal({
            isOpen: true,
            msg: data.message,
            msgtype: data.success,
          });
        }
      },
    }
  );

  const { isLoading: isPostMutating, mutate: mutatePost } = useMutation(
    api.updateDispenseStock,
    {
      onSuccess: (data) => {
        if (data.status == 200) {
          setbStockUpdate(data.bStockUpdated);
          setDeletedDataSet([]);

          if (data.data.success == 0) {
            props.openNoticeModal({
              isOpen: true,
              msg: data.data.message,
              msgtype: data.data.success,
            });

            // swal(data.data.message, "", "warning");
          } else {
            refetch();
            props.openNoticeModal({
              isOpen: true,
              msg: data.data.message,
              msgtype: data.data.success,
            });

            //swal(data.data.message, "", "success");
          }
        } else {
          props.openNoticeModal({
            isOpen: true,
            msg: data.data.message,
            msgtype: data.data.success,
          });
        }
      },
    }
  );

  const isSubmitting = isUpdateMutating || isPostMutating;

  const runDispenseUpdate = (payload) => {
    if (saveInFlightRef.current || isPostMutating) return;
    saveInFlightRef.current = true;
    mutateUpdate(payload, {
      onSettled: () => {
        saveInFlightRef.current = false;
      },
    });
  };

  const handleAdd = (NonOrderProductData) => {
    setManyTableData(NonOrderProductData);
    setUpdatedDetailGridData(NonOrderProductData);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    let data = { ...formData };
    data[name] = value;
    setFormData(data);
    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleReset = () => {
    setFormData({
      TransactionDate: "",
      //SupplierInvDate: "",
      //SupplierInvNo: "",
      TransactionNo: "",
      FacilityId: FacilityId,
      TransactionTypeId: 4,
      TransactionId: "",
      //ReceiveFrom:"",
      //OrderNo:"",
      PreparedBy: "",
      ApprovedBy: "",
      ItemGroupId: "",
    });
  };

  const validateForm = (formData) => {
    let validateFields = [
      "TransactionDate",
      "TransactionNo",
      "PreparedBy",
      "ApprovedBy",
    ];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] =
          DispensingLanguage[lan][menukey]["field is Required !"];
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  const deleteDispenseInv = (data) => {
    console.log(ManyTableData);
    let newarray = ManyTableData.filter((element) => element !== data);

    setManyTableData(newarray);
    setUpdatedDetailGridData(newarray);
    if (data.TransactionItemId != null) {
      let newDeletedDataSet = [data.TransactionItemId];
      setDeletedDataSet(newDeletedDataSet.concat(deletedDataSet));
    }
  };

  const handleUpdate = async (e) => {
    if (saveInFlightRef.current || isSubmitting) return;
    if (validateForm(formData)) {
      let fDtat = {
        ...formData,
        ManyJsonSave: ManyTableData,
        UserName: UserName,
        lan: lan,
        deletedDataSet: deletedDataSet,
      };
      runDispenseUpdate(fDtat);
    }
  };

  const handlePost = async (e) => {
    if (saveInFlightRef.current || isSubmitting) return;
    if (validateForm(formData)) {
      //let fDtat={...formData,'ManyJsonSave':ManyTableData,"bStockUpdated":1,'deletedDataSet':deletedDataSet};
      //mutateUpdate(fDtat);

      // Start Post Alert

      swal({
        title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
        text: t(
          DispensingLanguage[lan][menukey][
            "Do you really want to post the stock?"
          ]
        ),
        icon: "warning",
        buttons: [
          t(DispensingLanguage[lan][menukey]["No"]),
          t(DispensingLanguage[lan][menukey]["Yes"]),
        ],
        dangerMode: true,
      }).then((willAction) => {
        if (willAction) {
          //setStockPost(true);
          if (saveInFlightRef.current || isSubmitting) return;
          let fDtat = {
            ...formData,
            ManyJsonSave: ManyTableData,
            UserName: UserName,
            lan: lan,
            bStockUpdated: 1,
            deletedDataSet: deletedDataSet,
          };
          runDispenseUpdate(fDtat);
        } else {
          setbStockUpdate(0);
          let route = `${TransactionId}`;
          props.history.push(route);
        }
      });
      // End Post Alert
    }
  };

  const setUpdatedDetailsGridDataHandler = (rows) => {
    if (saveInFlightRef.current || isSubmitting) return;
    if (validateForm(formData)) {
      let fDtat = {
        ...formData,
        ManyJsonSave: rows,
        UserName: UserName,
        lan: lan,
        deletedDataSet: deletedDataSet,
      };
      runDispenseUpdate(fDtat);
    }

    // const updateManyTableData = ManyTableData.map((row) => {

    //   if (row.SKU == rows.SKU) {
    //     row.Quantity = rows.Quantity;
    //     row.BatchNo = rows.BatchNo;
    //     row.ExpiryDate = rows.ExpiryDate;
    //   }
    //   return row;
    // });
    // console.log('updateManyTableData: ', 'sdgfjsgfsgfjshgfdhsgfhdsfg');
    setManyTableData(rows);
  };

  // useEffect(() => {

  // }, []);

  return (
    <>
      <DispenserFormData
        errorObject={errorObject}
        addProductForm={false}
        formData={formData}
        handleChange={handleChange}
        handleCheck={handleCheck}
        handleReset={handleReset}
        handleUpdate={handleUpdate}
        ManyTableData={updatedDetailGridData}
        handleRDateChange={handleRDateChange}
        selectedDate={selectedDate}
        handleAdd={handleAdd}
        bStockUpdate={bStockUpdate}
        setUpdatedDetailsGridDataHandler={setUpdatedDetailsGridDataHandler}
        handlePost={handlePost}
        deleteDispenseInv={deleteDispenseInv}
        generatedInvoiceNo={generatedInvoiceNo}
        bFirst={bFirst}
        {...props}
        isSubmitting={isSubmitting}
      />
    </>
  );
};

export default EditDispenser;
